import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService, BASE_URL_BULK_UPLOAD } from '../app.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class StatusProcessService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  getStatus(token: any): Observable<any> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/status-process/${token}`;
    return this.get(this.endpoint);
  }

  getResult(token: any): Observable<any> {
    this.endpoint = `${BASE_URL_BULK_UPLOAD}/status-process/${token}/result`;
    return this.get(this.endpoint);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/status-process.service.ts